import { FormControl } from "@mui/material";
import { motion } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import SelectEstado from "../../../../components/SelectEstado/SelectEstado";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import CoresRedux from "../../../../contexts/Cor";
import NomeTabelaRedux from "../../../../contexts/NomeTabela";
import TabelaRedux from "../../../../contexts/Tabela";
import DadosUsuarioRedux from "../../../../contexts/Usuario";
import { TaxaIcmsModel } from "../../../../models/TaxaIcms";
import { valorMask } from "../../../../regex/valorMask";
import { getRegras } from "../../../../services/ModuloGerenciador/Geral.ts";
import {
	cadastraTaxaIcms,
	deleteTaxaIcmsPorId,
	editaTaxaIcmsPorId,
	getTaxaIcms,
	getTaxaIcmsPorId,
} from "../../../../services/ModuloGerenciador/TaxaIcms";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario";
import "./TaxaIcms.css";

function TaxaIcms() {
	const { dadosCoresRedux } = useContext(CoresRedux);

	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState(new TaxaIcmsModel({}));

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const navigate = useNavigate();

	const buscarTaxaIcms = async () => {
		setLoading(true);
		await getTaxaIcms(dadosUsuarioRedux.token).then((result) => {
			setDadosTabela(result.data);
			setTabelaRedux({});
			setLoading(false);
		});
	};

	const cadastrar = async () => {
		if (
			(values.taxa !== "" ||
				values.ufOrigem !== "" ||
				values.ufDestino !== "") &&
			validator.taxa === "true" &&
			validator.ufOrigem === "true" &&
			validator.ufDestino === "true"
		) {
			if (values.taxa.split(",").length === 1) {
				values.taxa = values.taxa + ",00";
			}
			setLoading(true);
			await cadastraTaxaIcms(values, dadosUsuarioRedux.token)
				.then((result) => {
					if (result.status === 200) {
						buscarTaxaIcms();
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaTaxaIcmsPorId(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					buscarTaxaIcms();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				setTextoErro(error.response.data);
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarTaxaIcmsPorId = async () => {
		setLoading(true);
		await getTaxaIcmsPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarTaxaIcmsPorId = async () => {
		setLoading(true);
		await deleteTaxaIcmsPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarTaxaIcms();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				setTextoErro(error.response.data);
				setOpenToastErro(true);
			});
	};

	const title = useMemo(() => {
		if(editando) return "Detalhes de Taxa Icms";
		if(telaCadastro) return "Cadastro de Taxa Icms";
		return "Taxa Icms";
	}, [editando, telaCadastro]);

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
		setValidator((current) => ({ ...current, taxa: "false" }));
		setValidator((current) => ({ ...current, ufOrigem: "false" }));
		setValidator((current) => ({ ...current, ufDestino: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarTaxaIcmsPorId();
		}
	}, [editando]);

	useEffect(() => {
		buscarTaxaIcms();
	}, []);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	useEffect(() => {
		if (dadosUsuarioRedux.regras !== undefined) {
			dadosUsuarioRedux.regras.forEach((element) => {
				if (element == "Uso Comum") {
					setSemAutorizacao(false);
				}
			});
		} else {
			verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
			getRegras(
				dadosUsuarioRedux.token,
				dadosUsuarioRedux.usuario.idUsuario
			).then((result) => {
				let regras = [];
				result.data.forEach((dado) => {
					regras.push(dado.regras.regra);
					if (dado.regras.regra == "Uso Comum") {
						setSemAutorizacao(false);
					}
				});
				dadosUsuarioRedux.regras = regras;
				setDadosUsuarioRedux(dadosUsuarioRedux);
			});
		}
	});

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					<NavbarV3 title={title} selecionado="Taxa ICMS" />
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					<NavbarV3 title={title} selecionado="Taxa ICMS" />
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							{!telaCadastro ? (
								<div className="embarques">
									<TabelaV2
										setTelaCadastro={setTelaCadastro}
										setEditando={setEditando}
										classeSelecionado="idTaxaIcms"
										nomeClasse1="outer-wrapper-cidade"
										nomeClasse2="table-wrapper-cidade-v2"
										colunas={dadosTabelaRedux.TaxaIcms}
										dados={dadosTabela}
									/>
									<div className="container-botoes-cliente">
										<div>
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Cadastrar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setTelaCadastro(true);
													setEditando(false);
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-editar"
												classText="button-texto-editar"
												titulo="Editar"
												icone="iconeEdit"
												cor="#CDCDCD"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setTelaCadastro(true);
														setEditando(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-deletar"
												classText="button-texto-cadastrar"
												titulo="Deletar"
												icone="iconeDelete"
												cor="#DC2D2D"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setOpen(true);
														setTextoSucesso("Deletado Com Sucesso");
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
									</div>
								</div>
							) : (
								<div>
									<div className="indicadores">
										<div className="texto-cadastro">
											<p className="indicador-emb">{"Dados de TaxaIcms /"}</p>
											{editando ? (
												<p className="indicador-emb">{"Detalhes de TaxaIcms"}</p>
											) : (
												<p className="indicador-emb">{"Cadastro de TaxaIcms"}</p>
											)}
											<HeaderCadastro texto="" />
											</div>
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										</div>
									</div>
									<div className="flex-column">
										<div className="container-select-emb">
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															TaxaIcms:
														</p>
														<input
															type="text"
															className="input-emb"
															style={{ width: "270px" }}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	taxa: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	taxa: "true",
																}));
															}}
															placeholder="Ex: 12"
															value={valorMask(values.taxa)}
														/>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															UF Origem:
														</p>
														<FormControl sx={{ width: 270 }}>
															<SelectEstado
																onChange={(selectedOption) => {
																	setValues((current) => ({
																		...current,
																		ufOrigem: selectedOption.value,
																	}));
																	setValidator((current) => ({
																		...current,
																		ufOrigem: "true",
																	}));
																}}
																value={values.ufOrigem}
															/>
														</FormControl>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															UF Destino:
														</p>
														<FormControl sx={{ width: 270 }}>
															<SelectEstado
																onChange={(selectedOption) => {
																	setValues((current) => ({
																		...current,
																		ufDestino: selectedOption.value,
																	}));
																	setValidator((current) => ({
																		...current,
																		ufDestino: "true",
																	}));
																}}
																value={values.ufDestino}
															/>
														</FormControl>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="botoes-embalagem">
										{editando ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													editar();
													setTelaCadastro(false);
													setEditando(false);
													setValues({});
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (
														values.taxa !== "" &&
														values.ufDestino !== "" &&
														values.ufOrigem !== "" &&
														validator.taxa === "true" &&
														validator.ufDestino === "true" &&
														validator.ufOrigem === "true"
													) {
														cadastrar();
														setValues({});
														setTelaCadastro(false);
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										)}
										<CustomButtonV2
											classCss="custom-button-cancelar"
											classText="button-texto-cancelar"
											titulo="Cancelar"
											cor="#0946B8"
											valor={values}
											onClick={() => {
												setValues({});
												setTelaCadastro(false);
												setEditando(false);
												setTabelaRedux({});
											}}
										/>
									</div>
								</div>
							)}
							<div>
								<ModalConfirmacao
									titulo="Deletar"
									texto="Deseja Deletar?"
									tituloConfirmar="Confirmar"
									tituloCancelar="Cancelar"
									open={open}
									onClose={handleClose}
									onClick={deletarTaxaIcmsPorId}
								/>
								<ModalUsuario
									titulo="Usuário"
									tituloConfirmar="OK"
									open={openUsuario}
									onClose={handleCloseUsuario}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}

export default TaxaIcms;
